import { SearchOutlineIcon } from '@carboncopyco/icons';
import { ColorHex, InputText } from '@carboncopyco/ui';
import React, { useEffect, useImperativeHandle, useState } from 'react';
import { useDebounce } from 'use-debounce';
import { useUrlState } from '../utils';

type SearchInputProps = { placeholder?: string };

export const SearchInput = React.forwardRef<any, SearchInputProps>(
  ({ placeholder }, ref) => {
    const [urlState, setUrlState] = useUrlState<{
      query?: string;
    }>({
      query: '',
    });
    const [searchInputState, setSearchInputState] = useState<string>(
      urlState.query
    );
    const [debouncedQuery] = useDebounce(searchInputState, 500);
    const resetSearchInput = () => setSearchInputState('');

    useEffect(() => {
      setUrlState({
        ...urlState,
        query: debouncedQuery || undefined,
      });
    }, [debouncedQuery]);

    useImperativeHandle(ref, () => ({ resetSearchInput }));

    return (
      <InputText
        placeholder={placeholder || 'Search'}
        size="lg"
        leftElement={<SearchOutlineIcon color={ColorHex.natural300} />}
        value={searchInputState}
        onChange={(event) => setSearchInputState(event.target.value)}
      />
    );
  }
);

SearchInput.displayName = 'SearchInput';
